// Angle units data for conversion routes
// Base unit: degree

export const angleUnits = [
  { id: 'degree', name: 'Degree', symbol: '°', plural: 'Degrees', factor: 1 },
  { id: 'radian', name: 'Radian', symbol: 'rad', plural: 'Radians', factor: 57.29577951 },
  { id: 'gradian', name: 'Gradian', symbol: 'gon', plural: 'Gradians', factor: 0.9 },
  { id: 'arcminute', name: 'Arcminute', symbol: "'", plural: 'Arcminutes', factor: 1/60 },
  { id: 'arcsecond', name: 'Arcsecond', symbol: '"', plural: 'Arcseconds', factor: 1/3600 },
  { id: 'turn', name: 'Turn', symbol: 'tr', plural: 'Turns', factor: 360 },
  { id: 'milliradian', name: 'Milliradian', symbol: 'mrad', plural: 'Milliradians', factor: 0.05729577951 },
  { id: 'quadrant', name: 'Quadrant', symbol: 'quad', plural: 'Quadrants', factor: 90 },
  { id: 'sextant', name: 'Sextant', symbol: 'sext', plural: 'Sextants', factor: 60 },
];

// Popular conversions matching common usage
export const popularAngleConversions = [
  { from: 'degree', to: 'radian' },
  { from: 'radian', to: 'degree' },
  { from: 'degree', to: 'gradian' },
  { from: 'gradian', to: 'degree' },
  { from: 'radian', to: 'gradian' },
  { from: 'gradian', to: 'radian' },
  { from: 'degree', to: 'arcminute' },
  { from: 'arcminute', to: 'degree' },
  { from: 'degree', to: 'arcsecond' },
  { from: 'arcsecond', to: 'degree' },
  { from: 'arcminute', to: 'arcsecond' },
  { from: 'arcsecond', to: 'arcminute' },
  { from: 'degree', to: 'turn' },
  { from: 'turn', to: 'degree' },
  { from: 'radian', to: 'milliradian' },
  { from: 'milliradian', to: 'radian' },
];

export const getUnitById = (id) => angleUnits.find(unit => unit.id === id);

export const convertAngle = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const degrees = value * fromUnit.factor;
  return degrees / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => `Convert ${fromUnit.plural} to ${toUnit.plural}`;

export const generateSEODescription = (fromUnit, toUnit) => {
  const result = convertAngle(1, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000 ? result.toExponential(4) : result.toPrecision(6).replace(/\.?0+$/, '');
  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online angle unit converter.`;
};
